import React from 'react';
import i from './IconNames';
import icons from './icons';

const SVGIcon = ({name, ...restProps}) => {
  const iconsList = Object.values(i);
  if (iconsList.indexOf(name) > -1) {
    const RequestedIcon = icons[name];
    return <RequestedIcon {...restProps} />;
  } else {
    return null;
  }
};
export default SVGIcon;
